import { render } from "./BaseButtonSpinner.vue?vue&type=template&id=0fb03026"
import script from "./BaseButtonSpinner.vue?vue&type=script&lang=js"
export * from "./BaseButtonSpinner.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0fb03026"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fb03026', script)) {
    api.reload('0fb03026', script)
  }
  
  module.hot.accept("./BaseButtonSpinner.vue?vue&type=template&id=0fb03026", () => {
    api.rerender('0fb03026', render)
  })

}

script.__file = "src/ui/buttons/BaseButtonSpinner.vue"

export default script